import React from 'react';
import classNames from 'classnames/bind';
import styles from './MobileFilterToggle.module.scss';
import FilterIcon from '../svg/mobile-filter.svg';

interface IFilterToggleProps {
  className?: string;
  onClick?: () => void;
}

const MobileFilterToggle = ({
  className = '',
  onClick = () => {}
}: IFilterToggleProps) => (
  <button
    className={classNames(className, styles.MobileFilterButton)}
    type="button"
    onClick={(e) => {
      e.preventDefault();
      onClick();
    }}
  >
    <FilterIcon />
  </button>
);

export default MobileFilterToggle;
